const NarvBarLeftPart2 = () => {
  return (
    <div>
      <div className="box-desc-footer-left">
        <div>
          <p className="M-tittle">Perfil de Consulta</p>
        </div>
        <div className="box-all-desc">
          <div>
            <a className="a-ref" href="#personal">
              <p className="desc-title-leftbar">Información Personal</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#ABM ">
              <p className="desc-title-leftbar">Abm de Documentos</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#Legajo ">
              <p className="desc-title-leftbar">Legajo</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#economica">
              <p className="desc-title-leftbar">Información Económica</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#income">
              <p className="desc-title-leftbar">Pagos y Cobros</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#empleador">
              <p className="desc-title-leftbar">Información Empleador</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#relacion">
              <p className="desc-title-leftbar">Relación con la Mutual</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#politica">
              <p className="desc-title-leftbar">Información Pep</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#terrorismo">
              <p className="desc-title-leftbar">Información Terrorismo</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#matriz">
              <p className="desc-title-leftbar">Matriz de Variables</p>
            </a>
          </div>
          <div>
            <a className="a-ref" href="#glosario">
              <p className="desc-title-leftbar">Glosario</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NarvBarLeftPart2;
